import React from 'react';
import { BookOpenIcon, ShoppingCartIcon } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" data-id="element-177">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-178">
        <div className="flex items-center space-x-2" data-id="element-179">
          <BookOpenIcon className="h-6 w-6 text-amber-600" data-id="element-180" />
          <span className="font-bold text-xl text-amber-800" data-id="element-181">
            RecetasExpress
          </span>
        </div>
        <nav className="hidden md:flex space-x-6" data-id="element-182">
          <a href="#caracteristicas" className="text-amber-900 hover:text-amber-600 transition" data-id="element-183">
            Características
          </a>
          <a href="#beneficios" className="text-amber-900 hover:text-amber-600 transition" data-id="element-184">
            Beneficios
          </a>
          <a href="#testimonios" className="text-amber-900 hover:text-amber-600 transition" data-id="element-185">
            Testimonios
          </a>
        </nav>
        <a href="https://productivetips.com/cart/45129127657658:1?checkout" className="flex items-center bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-3 py-1.5 md:px-4 md:py-2 rounded-lg shadow-md transition duration-300 text-sm md:text-base" data-id="element-186">
          <ShoppingCartIcon className="h-3.5 w-3.5 md:h-4 md:w-4 mr-1.5 md:mr-2" data-id="element-187" />
          <span data-id="element-188">Comprar - $9.97</span>
        </a>
      </div>
    </header>;
}